import React from "react";
import type { ToastOptions } from "react-toastify";

import FellowButton from "~/ui/button";
import { HelpCenterLink } from "~/ui/legacyFellowIndex";
import toast from "~/ui/toast";

import mockStyles from "~/meetings/legacy/css/MockMeetingPage.module.css";
import mockPanelStyles from "~/nav/panels/MockMeetings/MockMeetingsPanel.module.css";

function navigateToSignup() {
	window.location.replace("https://fellow.app/auth/signup/");
}

export function createWorkspaceToast(options: ToastOptions = {}) {
	return toast.success(
		<div className={mockStyles.toastText}>
			Create your own workspace and invite your teammates to take advantage of the full Fellow experience.{" "}
			<HelpCenterLink articleId="4332910">Learn more</HelpCenterLink>
		</div>,
		{
			actions: (
				<FellowButton size="normal" variant="primary" className={mockStyles.toastButton} onClick={navigateToSignup}>
					Try for free
				</FellowButton>
			),
			closeOnClick: false,
			autoClose: false,
			draggable: false,
			...options,
		},
	);
}

export function CreateWorkspaceCard() {
	return (
		<div className={mockPanelStyles.workspaceCard}>
			<p>
				Create your own workspace and invite your teammates to take advantage of the full Fellow experience.{" "}
				<HelpCenterLink articleId="4332910">Learn more</HelpCenterLink>
			</p>
			<FellowButton size="wide" variant="primary" onClick={navigateToSignup}>
				Try for free
			</FellowButton>
		</div>
	);
}
